import { FC } from 'react';
import { ProjectTranslations } from './ProjectTypes.ts';
import { CardBody, CardHeader, CardText, CardTitle, Col } from 'react-bootstrap';
import { Card } from 'react-bootstrap';
import ProjectTechnologies from './components/projectTechnologies/ProjectTechnologies.tsx';
import ProjectFeatures from './components/projectFeatures/ProjectFeatures.tsx';
import ProjectStatus from './components/projectStatus/ProjectStatus.tsx';
import ProjectUrl from './components/projectUrls/ProjectUrls.tsx';
import styles from './Project.module.scss';

/**
 * Props for the Project component.
 */
interface ProjectProps {
    projectData: ProjectTranslations;
}

const Project: FC<ProjectProps> = (props) => {
    const {
        projectData
    } = props;

    const {
        title,
        description,
        technologies,
        features,
        status,
        urls
    } = projectData;

    return (
        <Col
            lg={12}
            xl={6}
        >
            <Card
                className={`mb-5 ${styles.projectCard}`}
            >
                <CardHeader
                    className={styles.projectHeader}
                >
                    <CardTitle
                        className={`m-0 text-white ${styles.projectTitle}`}
                    >
                        {title}
                    </CardTitle>
                </CardHeader>
                <CardBody
                    className="p-0"
                >
                    <div
                        className="p-4 border-bottom"
                    >
                        <CardText
                            className={styles.projectDescription}
                        >
                            {description}
                        </CardText>
                        <ProjectTechnologies
                            technologiesTranslation={technologies}
                        />
                        <ProjectFeatures
                            features={features}
                        />
                    </div>
                    <ProjectUrl
                        urls={urls}
                    />
                    <ProjectStatus
                        status={status}
                    />
                </CardBody>
            </Card>
        </Col>
    );
}

export default Project;